import { Record, OrderedMap, List, Map } from "immutable";
import { formatCurrency } from "utilities";
import { BankAccountRecord } from "./company-record";
import { UserRecord } from "./user-record";
import { ProductRecord } from "./product-record";
import { ReportingIndustry } from "./reporting-industry";
import { ReportingAnchor } from "./reporting-anchor";
import { SupplyChainRecord } from "./supply-chain-record";
import { CASE_STATUS_TYPES, CASE_PRIORITY_TYPES, CASE_CATEGORY_TYPES } from "constants/enums";
import moment from "moment";
import _min from "lodash/min";
import _minBy from "lodash/minBy";
import { BANK_ACCOUNT_TYPES, NACH_MODES_TYPE } from "../constants";

export class CaseTaskRecord extends Record({
    assignment_date: null,
    assignment_type: null,
    case: null,
    create_date: null,
    created_by: null,
    delegation_index: null,
    end_date: null,
    from_stage: null,
    from_user: null,
    id: null,
    is_active: null,
    modified_by: null,
    modified_date: null,
    reassignment_reason: null,
    start_date: null,
    this_stage: null,
    this_user: null
}) {}

export class CaseRecord extends Record({
    id: 1,
    assignment_date: null,
    case_task: null,
    current_case_task: null,
    current_case_tasks: null,
    address_line_1: null,
    address_line_2: null,
    is_reassigned: null,
    case_type: null,
    city: null,
    state: null,
    pincode: null,
    district: null,
    anchor: null,
    anchors: [],
    company: null,
    seller: null,
    sellers: [],
    financial_year: null,
    distributor_name: null,
    total_sales: null,
    proposed_limit: null,
    bank: null,
    sales_manager_user: null,
    sales_manager_users: null,
    spoc_user: null,
    supply_chain: new SupplyChainRecord(),
    supply_chains: null,
    date_of_appointment: null,
    priority: null,
    progress_bar_cc: null,
    uuid: null,
    parent_case_detail: null,
    case_source: null,
    cibil_checked: null,
    cibil_ready: null,
    cibil_score: null,
    documents_count: null,
    reviewed_documents: null,
    non_reviewed_documents: null,
    created_by: null,
    case_status: null,
    tally_outstanding: null,
    processing_fee_amount: null,
    system_recommendation: null,
    status_welcome_call: null,
    sub_status_welcome_call: null,
    recommendation_status: null,
    supplychain_remarks: null,
    status: null,
    post_sanction_kit_status: null,
    is_seller_key_details_available: null,
    is_fee_available: null,
    is_scheme_created_on_lms: null,
    is_created_on_lms: null,
    ps_kit_available: null,
    is_disbursal_account_added: null,
    sanction_date: null,
    login_type: null,
    existing_case: null,
    is_refered_back: null,
    bank_comments_all_applicants: null,
    tat: null,
    industry_name: null,
    scheme_type_label: null,
    applicants: null,
}) {
    get companyId() {
        return this.company;
    }



    get cibilReportTable() {
        return this.company.cibilReportTable;
    }

    get task_id() {
        return this.case_task && this.case_task.id ? this.case_task.id : null;
    }

    get ps_kit_eligible() {
        return this.ps_kit_available && this.ps_kit_available.is_eligible ? "Yes" : "No";
    }

    get ps_kit_status() {
        return this.ps_kit_available && this.ps_kit_available.status;
    }

    get case_task_id() {
        if(this.current_case_task && this.current_case_task.id) {
            return this.current_case_task && this.current_case_task.id ? this.current_case_task.id : null;
        } else {
            return this.current_case_tasks ? this.current_case_tasks.id : null;
        }
    }

    get state_name() {
        return (this.state && this.state.name) || "--";
    }

    get city_name() {
        return (this.city && this.city.name) || "--";
    }

    get district_name() {
        return (this.district && this.district.name) || "--";
    }

    get company_name() {
        return this.buyer_name;
    }

    get task_aging() {
        return this.case_task && this.case_task.start_date
            ? moment(this.case_task.start_date).fromNow()
            : "--";
    }

    get case_delegation() {
        return this.case_task && this.case_task.delegation_index
            ? `Case moved: ${this.case_task.delegation_index} times`
            : "--";
    }

    get task_user() {
        return this.case_task && this.case_task.this_user
            ? this.case_task.this_user.full_name
            : "--";
    }

    getTaskId() {
        return this.case_task && this.case_task.id ? this.case_task.id : null;
    }
    getCompanyName() {
        return this.company.name;
    }
    getList() {
        return new List([
            ["Seller", this.seller.name],
            ["Anchor", this.anchor.name]
            // ["Sales Manager", this.sales_manager_user.full_name]
        ]);
    }
    // get case_type() {
    //     return CASE_CATEGORY_TYPES.findKey(_ => _ === this.case_type);
    // }
    // get is_reassigned() {
    //     return this.is_reassigned ? "Resubmitted" : "New";
    // }
    get assignment_date_value() {
        if(this.assignment_date && this.assignment_date.isValid()) {
            return this.assignment_date && this.assignment_date.format("DD/MM/YY hh:mm a");
        }
        if(this.current_case_tasks && this.current_case_tasks.assignment_date) {
            return moment(this.current_case_tasks.assignment_date).format("DD/MM/YY hh:mm a");
        }
        if(this.current_case_tasks) {
            const minCaseTask = _minBy(this.current_case_tasks, _ => moment(_.assignment_date).unix());
            return minCaseTask && moment(minCaseTask.assignment_date).format("DD/MM/YY hh:mm a");
        }
        if (this.current_case_task && this.current_case_task.assignment_date)
            return this.current_case_task.assignment_date.format("DD/MM/YY hh:mm a");

        if (this.case_task && this.case_task.assignment_date)
            return this.case_task.assignment_date.format("DD/MM/YY hh:mm a");
        return "--";
    }

    get assigned_user() {
        if (
            this.current_case_task &&
            this.current_case_task.this_user &&
            this.current_case_task.this_user.full_name
        )
            return this.current_case_task.this_user.full_name;
        if(this.current_case_tasks && this.current_case_tasks.this_user) {
            return this.current_case_tasks.this_user && this.current_case_tasks.this_user.full_name;
        }
        if(this.current_case_tasks) {
            const minCaseTask = _minBy(this.current_case_tasks, _ => moment(_.assignment_date).unix());
            return minCaseTask && minCaseTask.this_user && minCaseTask.this_user.full_name;
        }
        if (
            this.case_task &&
            this.case_task.this_user &&
            this.case_task.this_user.full_name
        )
            return this.case_task.this_user.full_name;
        return null;
    }

    get stage() {
        return (
            this.current_case_task &&
            this.current_case_task.this_stage &&
            this.current_case_task.this_stage.stage_name
        );
    }

    get date_of_appointment() {
        return this.supply_chain && this.supply_chain.date_of_appointment
            ? this.supply_chain.date_of_appointment.format("DD-MM-YYYY")
            : null;
    }
    get buyer_name() {
        return this.company ? this.company.name : null;
    }
    get seller_name() {
        return this.sellers
            && this.sellers.map(_ => _ ? `${_.name}` : "").join(", ");
    }
    get anchor_name() {
        return this.anchors
            && this.anchors.map(_ => _ && `${_.name}`).join(", ");
    }
    get sales_manager() {
        return this.sales_manager_user ? this.sales_manager_user.full_name : null;
    }
    get spoc_name() {
        return this.spoc_user ? this.spoc_user.name : null;
    }
    get spoc_email() {
        return this.spoc_user ? this.spoc_user.email : null;
    }
    get spoc_mobile() {
        return this.spoc_user ? this.spoc_user.phone : null;
    }

    get limit_basis_sales() {
        return this.supply_chain ? this.supply_chain.limit_basis_sales : null;
    }

    get score() {
        return this.supply_chain ? this.supply_chain.score_obtained : null;
    }

    // get system_recommendation() {
    //     return this.supply_chain
    //         ? this.supply_chain.system_recommendation
    //         : null;
    // }

    get current_user() {
        return this.case_task &&
            this.case_task.this_user &&
            this.case_task.this_user.full_name; 
    }

    get anchors_list() {
        return this.supply_chains
            && this.supply_chains.map(_ => _.anchor && `${_.anchor.name}`).join(", ");
    }

    get sellers_list() {
        return this.supply_chains
            && this.supply_chains.map(_ => _.seller && `${_.seller.name}`).join(", ");
    }

    get bank_name() {
        return this.bank && this.bank.short_name;
    }

    get created_by_details() {
        return this.created_by ?
            (this.created_by.first_name ? this.created_by.first_name : "") + " " +
            (this.created_by.last_name ? this.created_by.last_name : "") + " | " +
            (this.created_by.phone_no ? this.created_by.phone_no : "--") : "--";
    }

    // get proposed_limit() {
    //     return this.supply_chain ? this.supply_chain.proposed_limit : null;
    // }

    get status() {
        return null;
    }

    get limit_basis_90_pctl() {
        return this.supply_chain ? this.supply_chain.limit_basis_90_pctl : null;
    }

    get avg_monthly_no_sales() {
        return this.supply_chain
            ? this.supply_chain.avg_monthly_no_sales
            : null;
    }

    get avg_monthly_no_repayments() {
        return this.supply_chain
            ? this.supply_chain.avg_monthly_no_repayments
            : null;
    }

    get no_bounces() {
        return this.supply_chain ? this.supply_chain.no_bounces : null;
    }

    get bounces_to_repayments_perc() {
        return this.supply_chain
            ? this.supply_chain.bounces_to_repayments_perc
            : null;
    }

    get repayment_period_mean() {
        return this.supply_chain
            ? this.supply_chain.repayment_period_mean
            : null;
    }

    get no_dpd_95_perc_amt_gt_0() {
        return this.supply_chain
            ? this.supply_chain.no_dpd_95_perc_amt_gt_0
            : null;
    }

    get no_dpd_95_perc_amt_gt_0_perc() {
        return this.supply_chain
            ? this.supply_chain.no_dpd_95_perc_amt_gt_0_perc
            : null;
    }

    get no_dpd_95_perc_amt_gt_30() {
        return this.supply_chain
            ? this.supply_chain.no_dpd_95_perc_amt_gt_30
            : null;
    }

    get no_dpd_95_perc_amt_gt_30_perc() {
        return this.supply_chain
            ? this.supply_chain.no_dpd_95_perc_amt_gt_30_perc
            : null;
    }

    get no_dpd_95_perc_amt_gt_60() {
        return this.supply_chain
            ? this.supply_chain.no_dpd_95_perc_amt_gt_60
            : null;
    }
    get no_dpd_95_perc_amt_gt_60_perc() {
        return this.supply_chain
            ? this.supply_chain.no_dpd_95_perc_amt_gt_60_perc
            : null;
    }
    get no_dpd_95_perc_amt_gt_90() {
        return this.supply_chain
            ? this.supply_chain.no_dpd_95_perc_amt_gt_90
            : null;
    }
    get no_dpd_95_perc_amt_gt_90_perc() {
        return this.supply_chain
            ? this.supply_chain.no_dpd_95_perc_amt_gt_90_perc
            : null;
    }
    get retailer_share_of_the_total_sales_perc() {
        return this.supply_chain
            ? this.supply_chain.retailer_share_of_the_total_sales_perc
            : null;
    }

    get seller_count() {
        return this.tally_outstanding && this.tally_outstanding.seller_count;
    }

    get closing_balance() {
        return this.tally_outstanding && this.tally_outstanding.sum_closing_balance;
    }

    get last_sync_date() {
        return this.tally_outstanding && this.tally_outstanding.last_sync_date && moment(this.tally_outstanding.last_sync_date).format("DD/MM/YYYY");
    }

    getTableRow(stageId, stageName) {
        return this.toSeq()
            .toMap()
            .set("buyer", this.buyer_name)
            .set("seller", this.seller_name)
            .set("anchor", this.anchor_name)
            .set("id", this.id)
            .set("sales_manager_user", this.sales_manager_name)
            .set("spoc_user_name", this.spoc_user_name)
            .set("spoc_user_email", this.getSpocUserEmail())
            .set("spoc_user_mobile", this.getSpocUserMobile())
            .set("stageId", stageId)
            .set("stageName", stageName)
            .set("proposed_limit", +this.proposed_limit)
            .set("bank_name", this.bank_name)
            .set("uuid", this.uuid)
            .set("case_type", this.case_type && CASE_CATEGORY_TYPES.findKey(_ => _ === this.case_type))
            .set("is_reassigned", this.is_reassigned ? "Re-submitted" : "New")
            .set("sales_manager_user", this.sales_manager_user)
            .set("progress_bar_cc", this.progress_bar_cc)
            .toJS();
    }
}

// s

export class CaseDetailRecord extends Record({
    id: null,
    batch: null,
    company: null,
    seller: null,
    anchor: null,
    product: new ProductRecord(),
    bank: new BankAccountRecord(),
    bank_tenor: null,
    sales_manager_user: new UserRecord(),
    sales_manager_users: [],
    case_type: null,
    case_status: null,
    current_case_task: null,
    limit_applied: 0,
    total_sales: null,
    financial_year: null,
    date_of_appointment: null,
    proposed_limit: 0,
    previous_case_detail: null,
    previous_case_via_existing_limit: null,
    parent_fi_movement_cases: null,
    child_fi_movement_cases: null,
    proposed_limit_peak: 0,
    proposed_limit_adhoc: 0,
    seller_security_type: null,
    progress_percentage_cc: null,
    progress_percentage_ps: null,
    rejection_reason: null,
    rejection_remarks: null,
    remarks: null,
    sanction_limit: null,
    sanction_remarks: null,
    scheme: null,
    loan_track: null,
    is_financial_analysis_applied: false,
    internal_remarks: null,
    create_date: null,
    modified_date: null,
    created_by: null,
    modified_by: null,
    supply_chain: new SupplyChainRecord(),
    supply_chains: null,
    supplychain_remarks: null,
    sales_analysis_display_type: 1,
    sales_analysis_display_currency: 1,
    sales_with_anchor: null,
    computed_limit: null,
    average_monthly_sale: null,
    priority: null,
    proposed_date_of_signing_agreement: null,
    kyc_docs_received: null,
    process: null,
    lead_type: null,
    questionnaire: null,
    parent_case_detail: null,
    tally_outstanding: null,
    processing_fee_amount: null,
    sellers: [],
    recommendation_status: null,
    is_pd_submitted: null,
    is_scheme_added: null,
    is_scheme_dwd_sp_added : null,
    is_seller_key_details_available: null,
    is_fee_available: null,
    is_scheme_created_on_lms: null,
    initial_loaded_limit: null,
    sanction_condition: null,
    is_created_on_lms: null,
    prepaid_processing_fee: null,
    documentation_charges: null,
    is_processing_fee_paid: null,
    is_scheme_present_for_all_supplychains: null,
    sanction_condition_status: null,
    sanction_condition_status_remarks: null,
    is_deviation_allowed: null,
    perc_hold_back_less_than_10: null,
    industry_level_max_capping: null,
    can_terminate_sanction_condition: null,
    date_of_incorporation: null,
    is_withhold_account_added: null,
    is_disbursal_account_added: null,
    is_vendor_finance: null,
    industry: null,
    extra_data: {},
    use_statement_analyzer: null,
    login_type: null,
    esign_status: null,
    credit_sesso: null,
    existing_limit: null,
    is_pd_mandatory: null,
    limit_basis_sales_display: null,
    distributor_relationship_manager: null,
    primary_language: null,
    secondary_language: null,
    kyc_status: null,
    is_bnpl_case: null,
    is_term_loan_created_on_lms: null,
    is_all_mandatory_document_verified: null,
    is_bureau_detail_available: null,
    associate_cibil_applicable: null,
    d2r_limit: {},
    is_d2r_case: null,
    all_city_and_ownership_type: null,
    los_to_lms_checklist : null,
    co_lending_limit_split: null,
    mou_50_50_risk_sharing: null,
    anchors: null,
    business_product_type: null,
    default_bounce_charges: null,
    default_foreclosure_charges: null,
    default_processing_fee: null,
    pskit_re_signed: null,
    is_ps_kit_signed: null,
    deferral_json: null,
    deferral_tagged: null,
    comment_added_for_authority_approval: null,
    is_self_served_journey: null,
    tradelink_flag_2x: null,
    is_case_approved_by_authority: null,
    scheme_type: null,
    is_key_account: null,
    program_type: null,
    json_data: null,
    reporting_industry: new ReportingIndustry(),
    reporting_anchor: new ReportingAnchor(),
    is_balance_transfer_case: null,
    product_scheme_type: null,
    is_insurance_attached: null,
    is_insurance_mandatory: null,
    office_cpv_status: null,
    ftr_category: null,
    residence_cpv: null,
    is_green_channel: null,
    is_tl_params_available: null,
    default_processing_charges: null,
    is_insurance_consent_provided:null,
    is_insurance_exempted:null,
    scheme_sync_with_parent: null,
    current_rm_details: null,
    current_asm_details: null,
    is_deviation_tagged: null,
    breached_para_status: null,
    is_bundled: null,
    bundled_limit_percentage: null,
    enhancement_green_channel: null,
    pre_approval_leads: null,
    is_related_to_distributor: null,
    at_high_risk: null,
    seasonal_pre_approved_tl: null,
    growth_plan_parameter: null,
    risk_sharing_percentage: null,
    insurance_amortisation_amount: null,
    is_insurance_amortisation_applicable: null,
    applicants: null,
    case_type_sanctioned: null,
    is_high_value_case: null,
    is_office_cpv_done: null,
}) {
    get constitution_name() {
        return this.company && this.company.constitution_name;
    }

    getCurrentCaseTask(user, adminGroup) {
        let caseTask = this.current_case_task && this.current_case_task.find(_ => _.this_user && _.this_user.id === user);
        if(caseTask) {
            return caseTask;
        } 
        caseTask = this.current_case_task && this.current_case_task.find(_ => adminGroup.includes(_.this_stage));
        if(caseTask) {
            return caseTask;
        }
        else {
            return this.current_case_task[0];
        }
    }
    get priority_label() {
        return CASE_PRIORITY_TYPES.findKey(_ => _ === this.priority);
    }

    get JSONvalues() {
        const data = this.toSeq()
            .toMap()
            .filter((v, k) => !["scheme"].includes(k))
            .set("bank", this.bank && this.bank.id)
            .set("product", this.product && this.product.id)
            .set("reporting_industry", this.reporting_industry && this.reporting_industry.id)
            .set("reporting_anchor", this.reporting_anchor && this.reporting_anchor.id)
            .set(
                "financial_year",
                this.financial_year && this.financial_year.id
            )
            .set("sellers", this.sellers && this.sellers.map(_ => _.id))
            .toJS();
        if (!this.remarks || this.remarks.length === 0) {
            data.remarks = "No remarks";
        }
        return data;
    }

    get hasPrimarySalesManager() {
        return this.sales_manager_user && this.this.sales_manager_user.id;
    }

    get hasLendingPartner() {
        return this.bank && this.bank.id;
    }

    get allDocumentVerified() {
        return this.is_all_mandatory_document_verified;
    }

    get hasProduct() {
        return this.product && this.product.id;
    }
    
    get sanction_values() {
        return {
            sanction_limit: this.sanction_limit,
            sanction_remarks: this.sanction_remarks
        };
    }
    get status() {
        return CASE_STATUS_TYPES.findKey(_ => _ === this.case_status);
    }
    get roi() {
        return this.scheme && this.scheme.roi;
    }
    get tenure() {
        return this.bank_tenor || (this.scheme && this.scheme.tenure);
    }

    get scheme_roi() {
        return (this.scheme && this.scheme.roi) || "--";
    }
    get stop_billing_days() {
        return (this.scheme && this.scheme.stop_billing_days) || "--";
    }

    get business_vintage() {
        return `${moment().diff(
            moment(this.date_of_appointment),
            "months"
        )} months`;
    }
    get business_vintage_self() {
        return `${moment().diff(
            moment(this.date_of_incorporation),
            "months"
        )} months`;
    }

    get last_12_month_sales() {
        return this.supply_chain && this.supply_chain.net_sales_amount_last_12_months
            ? this.supply_chain.net_sales_amount_last_12_months
            : null;
    }

    get average_monthly_net_sales() {
        return this.supply_chain && this.supply_chain.avg_monthly_net_sales
            ? this.supply_chain.avg_monthly_net_sales
            : null;
    }

    get monthly_sales_denom() {
        const vintage = moment().diff(
            moment(this.date_of_appointment),
            "months"
        );
        if (vintage > 12) {
            return 12;
        }
        return vintage;
    }

    get level_of_engagement() {
        return _min([
            moment().diff(moment(this.date_of_appointment), "months"),
            12
        ]);
    }

    get dependence() {
        return `${this.proposed_limit / 400000} %`;
    }

    get promptness_payment() {
        return this.supply_chain.no_dpd_95_perc_amt_gt_60_perc
            ? `${this.supply_chain.no_dpd_95_perc_amt_gt_60_perc} %`
            : "0%";
    }

    get anchors_list() {
        return this.supply_chains
            ? this.supply_chains.map(_ => _.anchor && `${_.anchor.name}|${_.anchor.id}`)
            : null;
    }

    get sellers_list() {
        return this.supply_chains
            ? this.supply_chains.map(_ => _.seller && `${_.seller.name}|${_.seller.id}`)
            : null;
    }

    // get sellers() {
    //     return this.supply_chains
    //         ? this.supply_chains.map(_ => _.seller)
    //         : [];
    // }
    get sellersName(){
        return this.supply_chains
            ? this.supply_chains.map(_ => _.seller && _.seller.name)
            : [];
    }

    get anchors() {
        return this.supply_chains
            ? this.supply_chains.map(_ => _.anchor && _.anchor.name)
            : [];
    }

    getSummary() {
        return {
            company: this.getCompanyName(),
            seller: this.getSellerName(),
            anchor: this.getAnchorName(),
            bank: this.getBankName(),
            batch: this.getBatch(),
            product: this.getProduct(),
            sales_manager: this.getSalesManager(),
            sales_manager_users: this.getSalesManagerUsers(),
            status: this.status,
            anchors_list: this.anchors_list,
            sellers_list: this.sellers_list,
            login_type: this.login_type,
            existing_limit: this.existing_limit,
            supply_chain_anchor:  this.supply_chains && this.supply_chains.map(_ => _.anchor),
            supply_chain_seller:  this.supply_chains && this.supply_chains.map(_ => _.seller)
        };
    }

    getTallyOutStandingDetails() {
        return this.tally_outstanding && this.tally_outstanding.map(_ => ({
            ..._,
            last_sync_date: moment(_.last_sync_date).format("DD/MM/YYYY")
        }));
    }

    get companyId() {
        return this.company && this.company.id;
    }

    get associates() {
        return this.company ? this.company.associates : new List([]);
    }

    get associateRecords() {
        return this.company.associates;
    }

    get associateAddresses() {
        return this.company.addresses.filter(_ => _.associate);
    }

    get buyer_name() {
        return this.company ? this.company.name : null;
    }
    get seller_name() {
        return this.seller ? this.seller.name : null;
    }
    get anchor_name() {
        return this.anchor ? this.anchor.name : null;
    }
    get product_name() {
        return this.product && this.product.name ? this.product.name : null;
    }
    get lending_partner() {
        return this.bank && this.bank.name ? this.bank.name : null;
    }

    get bank_name() {
        return this.bank && this.bank.name ? this.bank.name : null;
    }

    get sales_with_anchor() {
        return this.supply_chain && this.supply_chain.amount_sales
            ? this.supply_chain.amount_sales
            : null;
    }

    get existing_limits() {
        return this.company ? this.company.existing_limits : 0;
    }

    get total_exposure() {
        return +this.proposed_limit + this.existing_limits;
    }
    get perc_sales_with_anchor() {
        return null;
    }

    getCompanyName() {
        return this.company && this.company.name ? this.company.name : null;
    }
    getSellerName() {
        return this.seller && this.seller.name ? this.seller.name : null;
    }
    getAnchorName() {
        return this.anchor && this.anchor.name ? this.anchor.name : null;
    }
    getBankName() {
        return this.bank && this.bank.name ? this.bank.name : null;
    }
    getBankCode() {
        return this.bank && this.bank.code ? this.bank.code : null;
    }
    getProduct() {
        return this.product && this.product.name ? this.product.name : null;
    }
    getBatch() {
        return this.batch && this.batch.name ? this.batch.name : null;
    }
    getSalesManager() {
        return this.sales_manager_user && this.sales_manager_user.name
            ? this.sales_manager_user.name
            : null;
    }
    getSalesManagerUsers() {
        return this.sales_manager_users && this.sales_manager_users.map(_ => _.full_name);
    }
    getStatus() {
        return this.status;
    }
    getLimitList() {
        return (
            new OrderedMap({
                "Limit Applied": formatCurrency(this.limit_applied),
                "Proposed Limit": formatCurrency(this.proposed_limit),
                "Proposed Peak Limit": formatCurrency(this.proposed_limit_peak),
                "Proposed Adhoc Limit": formatCurrency(this.proposed_limit_peak)
            })
                // .toList()
                .toArray()
        );
    }

    getAssociates() {   
        return this.company && this.company.getAssociates();
    }
    getGuarantors() {
        return this.company && this.company.getGuarantors();
    }
    getBankAccounts() {
        return this.company.getBankAccounts();
    }

    get limit_basis_sales() {
        return this.supply_chain ? this.supply_chain.limit_basis_sales : "--";
    }
    getCaseDetailFormValues() {
        return {
            company: this.getCompanyName(),
            product: this.getProduct(),
            bank: this.getBankName(),
            case_type: this.case_type,
            case_status: this.status,
            seller_security_type: this.seller_security_type,
            date_of_appointment: this.date_of_appointment && this.date_of_appointment.format("YYYY-MM-DD"),
            proposed_date_of_signing_agreement: this.proposed_date_of_signing_agreement,
            kyc_docs_received: this.kyc_docs_received
        };
    }
}

// export class SupplyChainRecord extends Record({}) {}

export class CaseSanctionRecord extends Record({
    case_id: null,
    sanction_amount: null,
    sanction_amount_peak: null,
    sanction_amount_peak_start_date: null,
    sanction_amount_peak_end_date: null,
    sanction_amount_adhoc: null,
    sanction_amount_adhoc_start_date: null,
    sanction_amount_adhoc_end_date: null,
    sanction_date: null
}) {
    getSanctionList() {
        return new OrderedMap({
            "Sanction Date": null,
            "Sanction Amount": formatCurrency(this.sanction_amount),
            "Sanction Amount(Peak)": formatCurrency(this.sanction_amount_peak),
            "Sanction Amount(Adhoc)": formatCurrency(
                this.sanction_amount_adhoc
            ),
            "Peak Duration": null,
            "Adhoc Duration": null
        });
    }
}

export class ChannelProductStatRecord extends Record({
    channel_product: null,
    value: null,
    amount: null,
    percentage: null,
    name: null,
    from_period: null,
    to_period: null,
    is_active: null
}) {
    getProducts(values) {
        return {
            channel_product:
                values.channel_product && values.channel_product.split("|")[0],
            name: values.name
                ? values.name
                : values.channel_product.split("|")[1],
            value: values.value,
            from_period: values.from_period.format("YYYY-MM-DD"),
            to_period: values.to_period.format("YYYY-MM-DD"),
            is_active: values.is_active
        };
    }
}


export class CaseAssociateRecord extends Record({
    id: null,
    case: null,
    type: null,
    is_main_borrower: null,
    is_authorized_signatory: null,
    company_associate: null,
    applicable_bureau: null,
    cibil_os: null,
    cibil_remarks: null,
    cibil_score: null,
    cibil_score_range: null,
    create_date: null,
    created_by: null,
    crif_remarks: null,
    crif_score_range: null,
    crif_score: null,
    is_active: null,
    personal_cibil_score: null,
    is_new_to_credit: null,
    is_cibil_requested: null,
    credit_checker_remarks: null,
    extra_data: null,
    vkyc: null,
}) {}
    

export class NachMandateStatusRecord extends  Record({
    buyer_name: null,
    case_id: null,
    document_upload_status: null,
    mobile: null,
    nach_details:  null,
    term_loan_instalment: null,
    lmrf_cheque_details: null,
    bank_details: Map({
        bank_account_id: null,
        account_number: null,
        account_holder_name: null,
        account_type: null,
        account_limit: null,
        ifsc: null,
        bank_name: null,
        bank_branch: null,
    }),
}) {
    getBankColums(){
        return Map({
            account_number: this.bank_details["account_number"],
            account_holder_name: this.bank_details["account_holder_name"],
            account_type: BANK_ACCOUNT_TYPES.findKey(val => val === this.bank_details["account_type"]),
            account_limit: this.bank_details["account_limit"],
            ifsc: this.bank_details['bank_branch']['ifsc_code'],
            bank_name: this.bank_details['bank_branch']['bank_name'],
            bank_branch: this.bank_details['bank_branch']['address']
        })
    }
    getBankAccountId(){
        return this.bank_details["id"]
    }

     getEmiDate(){
        return this.nach_details && this.nach_details.emi_date
    }

    getMandateType(){
        return  this.nach_details && this.nach_details.mandate_type;
    }

    getNachStatus(){
        return  this.nach_details && this.nach_details.nach_status;
    }

    getMandateTypeLabel(){
        return  NACH_MODES_TYPE.find(item => item.value === this.nach_details.mandate_type).label;
    }

    getTransferredTo(){
        return this.nach_details  && this.nach_details.digio_respone && this.nach_details.digio_respone.data && this.nach_details.digio_respone.data.bank_details.bank_name
    }


    getNachLink(){
        return this.nach_details && this.nach_details.url;
    }
}


